
import { supabase } from '../../supabase';
import { toast } from 'sonner';
import { adminError } from '@/lib/utils/admin-logger';

export async function createPaperVersion(
  paperId: string,
  title: string,
  abstract: string,
  fileUrl?: string,
  externalUrl?: string,
  publishedAt?: string
) {
  const version = "1.0";
  const now = new Date().toISOString();

  const { data: versionData, error: versionError } = await supabase
    .from('paper_versions')
    .insert({
      paper_id: paperId,
      version,
      title,
      abstract,
      file_url: fileUrl || '',
      external_url: externalUrl || null,
      url: externalUrl || null,
      published_at: publishedAt || now,
      changes: ['Initial version'],
    })
    .select()
    .single();

  if (versionError) {
    adminError('Error creating paper version:', versionError);
    
    // Clean up the paper if version creation fails
    await supabase.from('papers').delete().eq('id', paperId);
    
    toast.error('Failed to create paper version', { 
      description: versionError.message 
    });
    return null;
  }

  return versionData;
}
